"use strict";

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var FieldReader =
/*#__PURE__*/
function () {
  function FieldReader() {
    _classCallCheck(this, FieldReader);
  }

  _createClass(FieldReader, null, [{
    key: "fromDesc",
    value: function fromDesc(desc, srcName, level) {
      // tslint:disable-next-line:max-classes-per-file
      return new (
      /*#__PURE__*/
      function (_FieldReader) {
        _inherits(_class, _FieldReader);

        function _class() {
          _classCallCheck(this, _class);

          return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
        }

        _createClass(_class, [{
          key: "readField",
          value: function readField(source, convs) {
            return desc.valueOf(source[srcName || desc.simpleNameKey()], level);
          }
        }]);

        return _class;
      }(FieldReader))();
    }
  }, {
    key: "fromNumDesc",
    value: function fromNumDesc(desc, srcName, level) {
      // tslint:disable-next-line:max-classes-per-file
      return new (
      /*#__PURE__*/
      function (_FieldReader2) {
        _inherits(_class2, _FieldReader2);

        function _class2() {
          _classCallCheck(this, _class2);

          return _possibleConstructorReturn(this, _getPrototypeOf(_class2).apply(this, arguments));
        }

        _createClass(_class2, [{
          key: "readField",
          value: function readField(source, convs) {
            return desc.valueOf(convs.toBigNumber(source[srcName || desc.simpleNameKey()]), level);
          }
        }]);

        return _class2;
      }(FieldReader))();
    }
  }, {
    key: "fromDateDesc",
    value: function fromDateDesc(desc, srcName, level) {
      // tslint:disable-next-line:max-classes-per-file
      return new (
      /*#__PURE__*/
      function (_FieldReader3) {
        _inherits(_class3, _FieldReader3);

        function _class3() {
          _classCallCheck(this, _class3);

          return _possibleConstructorReturn(this, _getPrototypeOf(_class3).apply(this, arguments));
        }

        _createClass(_class3, [{
          key: "readField",
          value: function readField(source, convs) {
            return desc.valueOf(convs.toDate(source[srcName || desc.simpleNameKey()]), level);
          }
        }]);

        return _class3;
      }(FieldReader))();
    }
  }, {
    key: "fromIdDesc",
    value: function fromIdDesc(desc, srcName, level) {
      // tslint:disable-next-line:max-classes-per-file
      return new (
      /*#__PURE__*/
      function (_FieldReader4) {
        _inherits(_class4, _FieldReader4);

        function _class4() {
          _classCallCheck(this, _class4);

          return _possibleConstructorReturn(this, _getPrototypeOf(_class4).apply(this, arguments));
        }

        _createClass(_class4, [{
          key: "readField",
          value: function readField(source, convs) {
            return desc.valueOf(convs.toClassReferenceId(source[srcName || desc.simpleNameKey()]), level);
          }
        }]);

        return _class4;
      }(FieldReader))();
    }
  }, {
    key: "fromDocIdDesc",
    value: function fromDocIdDesc(desc, level) {
      // tslint:disable-next-line:max-classes-per-file
      return new (
      /*#__PURE__*/
      function (_FieldReader5) {
        _inherits(_class5, _FieldReader5);

        function _class5() {
          _classCallCheck(this, _class5);

          return _possibleConstructorReturn(this, _getPrototypeOf(_class5).apply(this, arguments));
        }

        _createClass(_class5, [{
          key: "readField",
          value: function readField(source, convs) {
            return desc.valueOf(convs.documentToClassId(source), level);
          }
        }]);

        return _class5;
      }(FieldReader))();
    }
  }]);

  return FieldReader;
}();

exports.FieldReader = FieldReader;